<template>
  <div id="base" class="" v-title title="首页">

    <!-- Unnamed (图片) -->
    <div id="u51" class="ax_default image">
      <img id="u51_img" class="img " src="@/images/shenqin/u51.png"/>
    </div>

    <!-- Unnamed (图片) -->
    <div id="u52" class="ax_default image">
      <img id="u52_img" class="img " src="@/images/shenqin/u52.png"/>
    </div>

    <!-- Unnamed (矩形) -->
    <div id="u53" class="ax_default box_1">
      <div id="u53_div" class=""></div>
    </div>
    <div style="position: absolute;top: 280px;width: 600px;left: 200px;">
      <el-input placeholder="请输入要查询的机构名称" v-model="inputs" style="width: 100%" />
      <div class="button1" @click="jichutijiao">查询</div>
    </div>

    <div class="akjfw">
      <div class="qian" @click="qian"> 前置审查</div>
      <div class="hei" @click="heib">黑名单查询</div>
      <div class="cha" @click="jig">机构信息查询</div>


    </div>
    <!-- Unnamed (矩形) -->
    <div id="u58" class="ax_default label">
      <div id="u58_div" class=""></div>
      <div id="u58_text" class="text ">
        <p style="text-align:center;"><span>河北省体育局版权所有 主办：河北省体育局 </span></p>
        <p style="text-align:center;"><span>地址：河北省石家庄市中山东路372号 邮编：050011 邮箱：hebeitiyuju@163.com </span></p>
        <p style="text-align:center;"><span>网站运维电话：0311-85266259 冀ICP备：2022017224号 冀公网安备：13010202002305号 </span></p>
      </div>
    </div>


  </div>
</template>

<script>

import {ElMessage} from "element-plus";

export default {
  name: 'RuKou',
  data() {
    return {
      inputs:'',
      form: {
        "companyName": "",
        "organizer": "",
        "organizerIdCard": "",
        "phone": "",
        "code": ''
      },
    }
  },
  created() {
  },
  methods: {
    qian() {
      this.$router.push('index')
    },
    heib() {
      this.$router.push('heibai')
    },
    jig() {
      this.$router.push('chaxun')
    },
    jichutijiao() {
      ElMessage.success('尚未找到该机构信息')
    }
  }
}
</script>
<style scoped>

#base {
  position: absolute;
  z-index: 0;
}

#u51_img {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 1000px;
  height: 227px;
}

#u51 {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 1000px;
  height: 227px;
}

#u51_text {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 0px;
  visibility: hidden;
  word-wrap: break-word;
}

#u52_img {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 342px;
  height: 76px;
}

#u52 {
  border-width: 0px;
  position: absolute;
  left: 32px;
  top: 62px;
  width: 342px;
  height: 76px;
}

#u52_text {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 0px;
  visibility: hidden;
  word-wrap: break-word;
}

#u53_div {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 1000px;
  height: 710px;
  background: inherit;
  background-color: rgba(242, 242, 242, 1);
  border: none;
  border-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}

#u53 {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 227px;
  width: 1000px;
  height: 710px;
}

#u53_text {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 0px;
  visibility: hidden;
  word-wrap: break-word;
}

#u54_div {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 253px;
  height: 42px;
  background: inherit;
  background-color: rgba(255, 255, 255, 0);
  border: none;
  border-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
  font-weight: 700;
  font-style: normal;
  font-size: 36px;
}

#u54 {
  border-width: 0px;
  position: absolute;
  left: 374px;
  top: 224px;
  width: 253px;
  height: 42px;
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
  font-weight: 700;
  font-style: normal;
  font-size: 36px;
}

#u54_text {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 253px;
  white-space: nowrap;
}

#u55_img {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 931px;
  height: 2px;
}

#u55 {
  border-width: 0px;
  position: absolute;
  left: 33px;
  top: 347px;
  width: 930px;
  height: 1px;
}

#u55_text {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 0px;
  visibility: hidden;
  word-wrap: break-word;
}

#u56_div {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 350px;
  height: 99px;
  background: inherit;
  background-color: rgba(255, 51, 51, 1);
  border: none;
  border-radius: 10px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  font-size: 28px;
  color: #FFFFFF;
}

#u56 {
  cursor: pointer;
  border-width: 0px;
  position: absolute;
  left: 74px;
  top: 310px;
  width: 350px;
  height: 99px;
  font-size: 28px;
  color: #FFFFFF;
}

#u56_text {
  border-width: 0px;
  position: absolute;
  left: 2px;
  top: 4px;
  text-align: center;
  width: 350px;
  word-wrap: break-word;
}

#u57_div {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 350px;
  height: 99px;
  background: inherit;
  background-color: rgba(255, 51, 51, 1);
  border: none;
  border-radius: 10px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  font-size: 28px;
  color: #FFFFFF;
}

#u57 {
  border-width: 0px;
  position: absolute;
  cursor: pointer;
  left: 74px;
  top: 452px;
  width: 350px;
  height: 99px;
  font-size: 28px;
  color: #FFFFFF;
}

#u57_text {
  border-width: 0px;
  position: absolute;
  left: 2px;
  top: 4px;
  text-align: center;
  width: 350px;
  word-wrap: break-word;
}

#u58_div {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 559px;
  height: 80px;
  background: inherit;
  background-color: rgba(255, 255, 255, 0);
  border: none;
  border-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  line-height: 20px;
}

#u58 {
  border-width: 0px;
  position: absolute;
  left: 221px;
  top: 792px;
  width: 559px;
  height: 80px;
  line-height: 20px;
}

#u58_text {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: -30px;
  width: 559px;
  white-space: nowrap;
}

#u59_div {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 350px;
  height: 99px;
  background: inherit;
  background-color: rgba(255, 51, 51, 1);
  border: none;
  border-radius: 10px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  font-size: 28px;
  color: #FFFFFF;
}

#u59 {
  border-width: 0px;
  position: absolute;
  left: 74px;
  top: 588px;
  width: 350px;
  height: 99px;
  font-size: 28px;
  color: #FFFFFF;
}

#u59_text {
  border-width: 0px;
  position: absolute;
  left: 2px;
  top: 4px;
  text-align: center;
  width: 350px;
  word-wrap: break-word;
}


#u60_div {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 200px;
  height: 99px;
  background: inherit;
  background-color: rgba(255, 51, 51, 1);
  border: none;
  border-radius: 10px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  font-size: 28px;
  color: #FFFFFF;
}

#u60 {
  cursor: pointer;
  border-width: 0px;
  position: absolute;
  left: 100px;
  top: 400px;
  width: 350px;
  height: 99px;
  font-size: 28px;
  color: #FFFFFF;
}

#u60_text {
  border-width: 0px;
  position: absolute;
  left: 2px;
  top: 4px;
  text-align: center;
  width: 200px;
  word-wrap: break-word;
}

#u61_div {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 200px;
  height: 99px;
  background: inherit;
  background-color: rgba(255, 51, 51, 1);
  border: none;
  border-radius: 10px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  font-size: 28px;
  color: #FFFFFF;
}

#u61 {
  border-width: 0px;
  position: absolute;
  cursor: pointer;
  left: 400px;
  top: 400px;
  width: 350px;
  height: 99px;
  font-size: 28px;
  color: #FFFFFF;
}

#u61_text {
  border-width: 0px;
  position: absolute;
  left: 2px;
  top: 4px;
  text-align: center;
  width: 200px;
  word-wrap: break-word;
}

#u62_div {
  border-width: 0px;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 200px;
  height: 99px;
  background: inherit;
  background-color: rgba(255, 51, 51, 1);
  border: none;
  border-radius: 10px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  font-size: 28px;
  color: #FFFFFF;
}

#u62 {
  border-width: 0px;
  position: absolute;
  cursor: pointer;
  left: 700px;
  top: 400px;
  width: 200px;
  height: 99px;
  font-size: 28px;
  color: #FFFFFF;
}

#u62_text {
  border-width: 0px;
  position: absolute;
  left: 2px;
  top: 4px;
  text-align: center;
  width: 200px;
  word-wrap: break-word;
}

.button1 {
  cursor: pointer;
  margin: 40px auto;
  width: 190px;
  height: 45px;
  background: inherit;
  background-color: rgba(255, 51, 51, 1);
  border: none;
  border-radius: 3px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #FFFFFF;
  text-align: center;
  line-height: 45px;
}

.akjfw {
  width: 1000px;
  height: 260px;
  background-image: url("../images/anquan/back.png") ;
  z-index: 9999;
  position: absolute;
  top: 450px;
  /*border:1px solid red;*/
  display: flex;
}

.qian{
  cursor: pointer;
  width: 140px;
  height: 140px;
  background-image: url("../images/anquan/qianbai.png");
  line-height: 330px;
  text-align: center;
  margin-left: 150px;
  margin-top: 50px;
}
.hei{
  cursor: pointer;
  width: 140px;
  height: 140px;
  background-image: url("../images/anquan/heibai.png") ;
  line-height: 330px;
  text-align: center;
  margin-left: 150px;
  margin-top: 50px;
}
.cha{
  cursor: pointer;
  width: 140px;
  height: 140px;
  background-image: url("../images/anquan/jigoubai.png") ;
  line-height: 330px;
  text-align: center;
  margin-left: 150px;
  margin-top: 50px;
}

.hei:hover{
  cursor: pointer;
  color: red;
  background-image: url("../images/anquan/heihong.png");
  margin-top: 45px;
  font-size: 18px;
  font-weight: bold;
}

.cha:hover{
  cursor: pointer;
  color: red;
  background-image: url("../images/anquan/jigouhong.png");
  margin-top: 45px;
  font-size: 18px;
  font-weight: bold;
}

.qian:hover{
  cursor: pointer;
  color: red;
  background-image: url("../images/anquan/qianhong.png");
  margin-top: 45px;
  font-size: 18px;
  font-weight: bold;
}


</style>
